import React from 'react';

export default function Row({ children }) {
    return <div className='row justify-content-xl-end justify-content-center'>{children}</div>;
}
